import { createSelector } from '@reduxjs/toolkit';
import { selectConfigFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { selectPageTypeId } from 'store/slice/navigation';
import { isOn } from 'core/window/bootstrapConfig';
import { FeatureName } from 'core/constant/FeatureName';

interface OwnProps {
    cityId?: number;
}

interface StateProps {
    config: BootstrapConfig;
    pageTypeId: number;
    isSearchBoxFeatureGroup: boolean;
    isPageContainerSpacing: boolean;
    isHomePageHorizontalCarousels: boolean;
}

export type TopActivitiesAroundYouProps = OwnProps & StateProps;

export const mapStateToProps = createSelector(
    selectConfigFromBootstrap,
    selectPageTypeId,
    selectFeatureBehaviorFromBootstrap,
    (config, pageTypeId, featureBehaviours): StateProps => {
        const isPageContainerSpacing = isOn(FeatureName.PageContainerSpacing, config);
        return {
            config,
            pageTypeId,
            isPageContainerSpacing,
            isSearchBoxFeatureGroup: featureBehaviours.SearchBoxFeatureGroup,
            isHomePageHorizontalCarousels: featureBehaviours.HomePageHorizontalCarousels,
        };
    },
);
